import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { PaginationEmpty } from 'domain/models/queryPagination'
import { ReadAdditionalSavingsQueryResponse } from 'domain/entities/additionalSavings'
import { AdditionalSavingsType } from 'domain/models/additionalSavings'
import { RootState } from 'presentation/redux/reducers'

const initialState: AdditionalSavingsType = {
  error: null,
  isLoading: false,
  additionalSavings: [],
  paginationAdditionalSavings: PaginationEmpty,
}

export const additionalSavingsSlice = createSlice({
  name: 'additionalSavings',
  initialState,
  reducers: {
    getAdditionalSavingsStart: (state: AdditionalSavingsType) => {
      state.isLoading = true
      state.error = null
    },
    getAdditionalSavingsSuccess: (
      state: AdditionalSavingsType,
      action: PayloadAction<ReadAdditionalSavingsQueryResponse>,
    ) => {
      state.isLoading = false
      state.additionalSavings = action.payload.entities
      state.paginationAdditionalSavings = action.payload.pagination
    },
    getAdditionalSavingsError: (state: AdditionalSavingsType, action: PayloadAction<string>) => {
      state.isLoading = false
      state.error = action.payload
    },
  },
})

export const additionalSavingsState = (state: RootState) => state.additionalSavings
export const { getAdditionalSavingsStart, getAdditionalSavingsSuccess, getAdditionalSavingsError } =
  additionalSavingsSlice.actions

export default additionalSavingsSlice.reducer
